import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function RegistroVenta() {
    const navigate = useNavigate();
    const { loteId, clienteId } = useParams();
    const [lote, setLote] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [asesores, setAsesores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [asesorSeleccionado, setAsesorSeleccionado] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    
    // Nuevos estados para los campos adicionales
    const [solicitudCompra, setSolicitudCompra] = useState('');
    const [datosPersonales, setDatosPersonales] = useState('');
    const [boletaCompra, setBoletaCompra] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Obtener usuario actual del localStorage
                const userData = JSON.parse(localStorage.getItem('user'));
                
                // Obtener datos del lote
                const loteRes = await fetch(`${API_BASE_URL}/api/lotes/${loteId}`);
                const loteData = await loteRes.json();
                setLote(loteData);

                // Obtener datos del cliente
                const clienteRes = await fetch(`${API_BASE_URL}/api/clientes/${clienteId}`);
                const clienteData = await clienteRes.json();
                setCliente(clienteData);

                // Obtener lista de asesores
                const asesoresRes = await fetch(`${API_BASE_URL}/api/asesores`);
                const asesoresData = await asesoresRes.json();
                setAsesores(asesoresData);
                
                // Si el usuario tiene id_asesor, preseleccionarlo
                if (userData.id_asesor) {
                    setAsesorSeleccionado(userData.id_asesor.toString());
                }

            } catch (err) {
                console.error('Error en fetchData:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [loteId, clienteId]);

    const handleConfirm = async () => {
        try {
            // Validar que los campos adicionales sean números enteros
            const solicitudCompraParsed = parseInt(solicitudCompra);
            const datosPersonalesParsed = parseInt(datosPersonales);
            const boletaCompraParsed = parseInt(boletaCompra);

            if (isNaN(solicitudCompraParsed)) {
                alert('Los números de documento deben ser valores numéricos');
                return;
            }

            // Obtener el usuario del localStorage
            const userData = JSON.parse(localStorage.getItem('user'));
            
            const response = await fetch(`${API_BASE_URL}/api/ventas`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_cliente: clienteId,
                    id_lote: loteId,
                    id_manzana: lote.id_manzana,
                    id_fraccion: lote.id_fraccion,
                    id_asesor: asesorSeleccionado,
                    user_usuario: userData.user_usuario,
                    solicitud_compra_venta: solicitudCompraParsed
                })
            });

            // Parsear la respuesta
			const data = await response.json();

			// Verificar si la respuesta indica un error
			if (!response.ok || data.success === false) {
				// Mostrar mensaje específico de error
				alert(data.error || 'Error al registrar la venta');
				
				// Opcional: redirigir a la lista de lotes o mantener en la página actual
				navigate('/');
				return;
			}

			// Venta exitosa
			alert('Pre-venta registrada exitosamente');
			navigate('/mis-reservas');
        } catch (err) {
            console.error('Error:', err);
            alert('Error al registrar la venta: ' + err.message);
        }
    };

    if (loading) return <div className="text-center p-4">Cargando datos...</div>;
    if (error) return <div className="text-red-600 p-4">Error: {error}</div>;

    return (
        <div className="max-w-2xl mx-auto p-4">
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold">Registro de Venta</h2>
                    <button 
                        onClick={() => navigate(-1)}
                        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                    >
                        Volver
                    </button>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg mb-6">
                    <h3 className="font-semibold mb-2">Datos del Lote</h3>
                    {lote && (
                        <>
                            <p>{lote.nombre_fraccion}</p>
                            <p>Manzana: {lote.numero_manzana}</p>
                            <p>Lote: {lote.numero_lote}</p>
                            <p>Dimensión: {lote.dimension_lote} m²</p>
                        </>
                    )}

                    <h3 className="font-semibold mt-4 mb-2">Datos del Cliente</h3>
                    {cliente && (
                        <>
                            <p>Nombre: {cliente.nombre_razon_social_cliente}</p>
                            <p>Documento: {cliente.nro_documento_cliente}</p>
                        </>
                    )}

                    <h3 className="font-semibold mt-4 mb-2">Selección de Asesor</h3>
                    <select
                        value={asesorSeleccionado}
                        onChange={(e) => setAsesorSeleccionado(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md"
                    >
                        <option value="">Seleccione un asesor</option>
                        {asesores.map(asesor => (
                            <option 
                                key={asesor.id_asesor} 
                                value={asesor.id_asesor}
                                // Si el asesor corresponde al usuario logueado, añadir (Usuario actual)
                                disabled={asesorSeleccionado && asesor.id_asesor.toString() !== asesorSeleccionado}
                            >
                                {asesor.nombre_apellido_asesor} 
                                {JSON.parse(localStorage.getItem('user')).id_asesor === asesor.id_asesor ? ' (Usuario actual)' : ''}
                            </option>
                        ))}
                    </select>

                    {/* Nuevos campos de documentación */}
                    <h3 className="font-semibold mt-4 mb-2">Plazo de Reserva</h3>
                    <div className="space-y-3">
                        <div>
                            <label className="block text-sm text-gray-700 mb-1">Cantidad de D&iacute;as</label>
                            <input
                                type="number"
                                value={solicitudCompra}
                                onChange={(e) => setSolicitudCompra(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                                placeholder="Ingrese un número"
                                required
                            />
                        </div>
                        
                        
                    </div>

                    <div className="mt-6 flex justify-end">
                        <button
                            disabled={!asesorSeleccionado || !solicitudCompra}
                            onClick={() => setShowConfirmModal(true)}
                            className="px-4 py-2 bg-[#2f62ab] text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300"
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal de Confirmación */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                        <h3 className="text-lg font-semibold mb-4">Confirmar Reserva</h3>
                        
                        {/* Resumen de la venta con más detalles */}
                        <div className="mb-4 space-y-2">
                            <p><span className="font-medium">Fracci&oacute;n:</span> {lote.nombre_fraccion}</p>
                            <p><span className="font-medium">Manzana:</span> {lote.numero_manzana}</p>
                            <p><span className="font-medium">Lote:</span> {lote.numero_lote}</p>
                            <div className="border-t my-2"></div>
                            <p><span className="font-medium">Cliente:</span> {cliente.nombre_razon_social_cliente}</p>
                            <p><span className="font-medium">Documento:</span> {cliente.nro_documento_cliente}</p>
                            <div className="border-t my-2"></div>
                            <p><span className="font-medium">Asesor:</span> {asesores.find(a => a.id_asesor.toString() === asesorSeleccionado)?.nombre_apellido_asesor}</p>
                            
                            {/* Mostrar información de los nuevos campos */}
                            <div className="border-t my-2"></div>
                            <p><span className="font-medium">D&iacute;as de Reserva:</span> {solicitudCompra}</p>                            
                        </div>
                        
                        <p className="mb-6 text-sm text-gray-600">¿Está seguro que desea confirmar la Reserva?</p>
                        
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                            >
                                No
                            </button>
                            <button
                                onClick={handleConfirm}
                                className="px-4 py-2 bg-[#2f62ab] text-white rounded hover:bg-blue-700"
                            >
                                Sí
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}